export default __webpack_public_path__ + "static/media/Inside.69f7e15c.png";